import React from 'react'
import { Modal } from 'react-bootstrap';

interface VideoModalProps {
    show: boolean;
    onHide: () => void;
    children: React.ReactNode;
}

export const VideoModal = (props: VideoModalProps) => {
    const { children } = props;
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: 'transparent' }}
            contentClassName="bg-transparent border-0"
        >
            <Modal.Body style={{ backgroundColor: '#000', textAlign: 'center' }}>{children}</Modal.Body>
        </Modal>
    );
}
